/* eslint-disable */
const namespace = 'applicationManagement';
const GETGROUPLIST = `${namespace}getGroupList`; // 获取项目组list
const GETSINGlEDATA = `${namespace}getSingleData`;
const GETSINGLEENCRYPTDATA = `${namespace}getEncryptSingleData`;
const GETTHREATSCENARIOS = `${namespace}getThreatScenarios`;
const GETINSERTSTATE = `${namespace}getInsertState`; // 获得接入的实时状态
export { GETGROUPLIST, GETSINGlEDATA, GETSINGLEENCRYPTDATA, GETTHREATSCENARIOS, GETINSERTSTATE };
